import { combineReducers } from 'redux';
import { BillingAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { PaymentMethod } from '../../../../types/items';

import {
  getPaymentMethodRequest,
  getPaymentMethodSuccess,
  getPaymentMethodFail,
} from '../actions';

type State = Loadable<PaymentMethod>;
type ReducerOf<T extends keyof State> = Reducer<State, BillingAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getPaymentMethodRequest.type:
    case getPaymentMethodFail.type:
      return null;

    case getPaymentMethodSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getPaymentMethodRequest.type:
      return true;

    case getPaymentMethodSuccess.type:
    case getPaymentMethodFail.type:
      return false;

    default:
      return state;
  }
};

const error: ReducerOf<'error'> = (state = false, action) => {
  switch (action.type) {
    case getPaymentMethodRequest.type:
    case getPaymentMethodSuccess.type:
      return false;

    case getPaymentMethodFail.type:
      return true;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  error,
});
